export enum ProductType {
  COUPON = "COUPON",
}
